export const actionColor = '#4a76b6';
export const secondaryColor = '#c0c0c0';
